export enum OnlineUserStatus {
    NotYetRegistered = -1,
    NoStatus = 0,
    Verified = 1,
    WaitingForEmailVerification = 2,
    Blocked = 3,
    TemporaryAccountForFacebookLogin = 4,
    AccountNeedToLinkToFacebook = 5,
    AccountNeedToLinkToGSIAndFacebook = 6,
    AccountNeedToLinkToIdentityAndFacebook = 7,
    AccountNeedToLinkToIdentity = 8,
    AddToUserLogins = 9,
    FromFacebookCanvasLogin = 10,
    AccountNoCustomerRecordWithAspNetUser = 11
}

export enum PaymentType {
    Cash = 2,
    CreditCard = 3,
    Cheque = 4,
    GiftVoucher = 5,
    CreditUsed = 6,
    PmPosting = 7,
    ArPosting = 8,
    BillToAccount = 9,
    CreditRefund = 11,
    DirectDebit = 12,
    RoomCharge = 13,
    Hicaps = 14,
    MarketSmartRewards = 15,
    Web = 16,
    Others = 30,
}


export enum OnlinePaymentTypesCode {
    PayPal = 1,
    EWay = 2,
    WorldPay = 3,
    ZipMoney = 4,
    FacebookPayment = 5,
    GiftVoucher = 6,
    SagePay = 7,
    MasterCardMigs = 8,
    AsiaPay = 9,
    Cash = 10
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6
}

export enum ItemCodeType {
    None = 0,
    Service = 1,
    Class = 2,
    Membership = 3,
    GiftVoucher = 4,
    Series = 13,
    Package = 9,
    FoodAndBeverage = 6,
    FacilityService = 12
}

export enum ProviderGenderPreference {
    Male = 1,
    Female = 2,
    Either = 3
}

export enum PaymentTypeGroup {
    Cash = 2,
    CreditCard = 3,
    Cheque = 4,
    GiftVoucher = 5,
    CreditUsed = 6,
    PmPosting = 7,
    ArPosting = 8,
    BillToAccount = 9,
    CreditRefund = 11,
    DirectDebit = 12,
    RoomCharge = 13,
    Hicaps = 14,
    MarketSmartRewards = 15,
    Web = 16,
    Others = 30,
}


export enum InvoiceDetailType {
    SurChargeItem = -3,
    SpecialBooking = -2,
    DefaultDeliveryItem = -1,
    Service = 1,
    Class = 2,
    Membership = 3,
    GiftVoucher = 4,
    FoodAndBeverage = 6,
    Package = 9,
    DestinationPackage = 10,
    DirectDebit = 11,
    FacilityService = 12,
    Series = 13,
    Stock = 20,
    Credit = 21,
    Tip = 22,
    Refund = 25,
    StockDelivery = 26,
    None = 0
}

export enum GiftVoucherOptionType {
    NotGiftVoucher = 0,
    IsElectronic = 1,
    IsGiftBoxed = 2,
    IsRegularPost = 3,
    IsExpressPost = 4,
    IsPrintAtHome = 5,
    IsPickUp = 6,
    IsPickUpBranch1 = 7,
    IsPickUpBranch2 = 8,
    IsPickUpBranch3 = 9,
    IsPickUpBranch4 = 10,
}

export enum PendingTrasactionStatus {
    Pending = 1,
    Successful = 2,
    Cancelled = 3,
    Deleted = 4,
    Failed = 5,
    OnlinePaymentSuccessful = 6,
    ConvertingToInvoice = 7,
    TransactionTimeOut = 8,
    TransactionTimeOutButPaid = 9
}

export enum WebSpecialType {
    NotYetImplemented = 0,
    ItemCodeGroup = 1,
    Service = 2,
    Package = 3,
    StockGroup = 4,
    Stock = 5
}

export enum StockCode {
    None = 0,
    Retail = 1,
    Professional = 2
}

export enum Gender {
    None = 0,
    Male = 1,
    Female = 2
}

export enum AppointmentDetailType {
    Preparation = 2,
    Special = 4,
    Class = 8,
    Service = 32,
    TurnAround = 1024,
    CustomerBreak = 32768,
    FandB = 1048576,
    FacilityService = 33554432,
    TurnaroundEquipment = 1073741824
}